import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../core/http.service';
import { Observable } from 'rxjs';
import { GlobalsService } from '../globals.service';
import { Audience } from 'src/app/models/services/audiences/movistar/audience';

@Injectable({
  providedIn: 'root'
})
export class MovistarAudiencesService {

  constructor(
    private httpService: HttpService,
    private globalsService: GlobalsService
  ) { }

  public getAudiences(): Observable<Audience[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/audiences/movistar/audiences`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }  

}